import { TAB_ACTION_TYPES } from '@constants/actionTypes/dashboardActionTypes';

export const INITIAL_STATE = 0;

export default (state = INITIAL_STATE, action = {}) => {
    switch (action.type) {
        case TAB_ACTION_TYPES.SET_ACTIVE_TAB:
            return action.activeTabIndex;
        case TAB_ACTION_TYPES.CLEAR_DASHBOARD_STATE:
            return INITIAL_STATE;
        default:
            return state;
    }
};